import {createPortal} from "react-dom";
import PropTypes from "prop-types";

export default function Modal({ title, show, onClose, children, className }) {
    const bodyElm = document.querySelector("body");
    let modalClass = show ? "modal modal--show" : "modal";

    if(className) {
        modalClass += ` ${className}`;
    }

    if (show) {
        bodyElm.style.overflow = "hidden"; // block scrolling body, when modal is shown
    }

    function close() {
        bodyElm.style.overflow = null;
        onClose();
    }

    const modal = <div className={modalClass}>
        <div className="modal__overlay" onClick={close}>
            <div className="modal__dialog" onClick={(event) => event.stopPropagation()}>
                <div className="modal__header">
                    <button className="modal__close" aria-label="Close" onClick={close}>
                        <span aria-hidden="true">×</span>
                    </button>
                    {title ? <h4 className="modal__title">{title}</h4> : ""}
                </div>
                <div className="modal__content">{children}</div>
            </div>
        </div>
    </div>;

    return createPortal(modal, document.body);
}

Modal.propTypes = {
    title: PropTypes.string,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};
